let installed = false;

const ePersonamAuth = {
  install(Vue, options) {
    Vue.mixin({
      mounted() {
        // Don't add stuff here!
        // Please use insead `app/helpers/application_helper.rb#js_config`
        window.userId = $('meta[name=user-id]').attr('content');
        window.userIsSuperUser = $('meta[name=user-is-super-user]').attr('content');
      },
    });
  },
};

export default ePersonamAuth;
